<template>
    <div>
        <page-header>
            <slot name="page-header"> OU / Groups </slot>
        </page-header>

        <page-loading v-if="loading && !orgUnit"></page-loading>

        <div v-else class="flex flex-col gap-10">
            <div class="flex flex-col items-start gap-8 lg:flex-row">
                <org-unit-folder />
                <div class="flex flex-col gap-2">
                    <div class="flex items-center gap-2">
                        <h2 class="text-xl font-extrabold m-0">{{ orgUnit.name }}</h2>
                        <span class="text-sm text-slate-500">{{ pluralize('Group', groupsCount, true) }}</span>
                    </div>
                </div>
            </div>

            <org-unit-group-list :orgUnit="orgUnit"></org-unit-group-list>
        </div>
    </div>
</template>
<script setup>
import PageHeader from '~/components/general/PageHeader.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import OrgUnitFolder from './OrgUnitFolder.vue';
import { orgUnitGroupsClient, orgUnitsClient } from '~/services';
import { ref, watch } from 'vue';
import { useToasted } from '~/composables/useToasted';
import { catchRequestError } from '~/utils/request';
import pluralize from 'pluralize';
import OrgUnitGroupList from './OrgUnitGroupList.vue';

const props = defineProps({
    orgUnitId: {
        type: Number,
        required: true,
    },
});

const teamId = Spark.state.currentTeam.id;
const toasted = useToasted();
const loading = ref(false);
const orgUnit = ref();
const groupsCount = ref(0);

const loadOrgUnit = async () => {
    if (loading.value) {
        return;
    }

    loading.value = true;
    try {
        const response = await orgUnitsClient.showOrgUnit(teamId, props.orgUnitId);
        orgUnit.value = response.data;

        const groupsCountResponse = await orgUnitGroupsClient.countOrgUnitGroups(teamId, props.orgUnitId);
        groupsCount.value = groupsCountResponse.data?.count || 0;
    } catch (e) {
        toasted.error(catchRequestError(e));
    } finally {
        loading.value = false;
    }
};

watch(
    () => props.orgUnitId,
    () => {
        loadOrgUnit();
    },
    {
        immediate: true,
    }
);
</script>
